// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".prop-65 .cls-1[data-v-262e5270],.prop-65 .cls-2[data-v-262e5270],.prop-65 .cls-3[data-v-262e5270]{stroke:#000;stroke-miterlimit:10}.prop-65 .cls-1[data-v-262e5270],.prop-65 .cls-3[data-v-262e5270]{stroke-width:1.44px}.prop-65 .cls-1[data-v-262e5270]{fill:#fff}.prop-65 .cls-2[data-v-262e5270]{fill:#fff200;stroke-width:3.447px}.prop-65 .cls-3[data-v-262e5270]{fill:none}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
